module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxMCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMzczOTIgMUwxLjIzODI4IDEwLjZINC45NjAzNkw0LjU0Njc5IDE3TDguNjgyNDMgNy40SDQuOTYwMzZMNS4zNzM5MiAxWiIgc3Ryb2tlPSIjRjZCNzE1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./static/website/images/vitamin-en.svg
// module id = ol9F
// module chunks = 1